export default "__VITE_ASSET__DahFTCzK__"